import { create } from "zustand";

type FileDescriptor = {
    filename: string;
    url: string;
    mimeType?: string;
    expiresAt?: string;
};

interface InitialState {
    visible: boolean;
    file: FileDescriptor | null;
}

interface Actions {
    open(file: FileDescriptor): void;
    close(): void;
}

const initialState: InitialState = {
    visible: false,
    file: null,
};

const useFileViewer = create<InitialState & Actions>(set => ({
    ...initialState,
    open: file => set({ visible: true, file }),
    close: () => set(initialState),
}));

export type { FileDescriptor };
export default useFileViewer;
